import React, { useEffect, useState } from 'react';
import { TableDefault } from '../../shared/components/table/TableDefault';
import { TableColumnType } from '../../shared/components/table/table-types';
import { Grid, Paper, Typography } from '@mui/material';

import { useCallAction, useEvent } from '@cobuildlab/react-simple-state';
import { fetchAdminUsersSubscriberEvents } from '../user/user-actions';
import { fetchEventsSubscriberEvent } from '../user/user-events';
import moment from 'moment';
import { UserSubscriberEvent } from '../user/user-types';

export const UserSubscriberEventsComp: React.FC<{userId?:number}> = ({userId}) => {
  const { data, total } = useEvent(fetchEventsSubscriberEvent);
  const [callDisabledUsers, loading] = useCallAction(fetchAdminUsersSubscriberEvents);

  const [pagination, setPagination] = useState({ pageSize: 10, page: 0 });
  useEffect(() => {
    callDisabledUsers({ page: pagination.page, pageSize: pagination.pageSize,user_id: userId});
  }, [callDisabledUsers, pagination.page, pagination.pageSize]);

  const users = data;

  const COLUMNS: TableColumnType<UserSubscriberEvent>[] = [
     {
      columnName: 'Fecha',
      columnValue: (item) => moment(item.created_at).format('DD-MM-YY / HH:mm:ss'),
      //sortableField: 'user_status',
    },
    {
      columnName: 'Evento',
      columnValue: (item) => item?.event.description || '',
      sortableField: 'email',
    },
  ];

  return (
    <>
      {' '}
      <Grid container spacing={2} mt={2.5}>
        <Grid item xs={12}>
          <Typography fontSize={{ sx: '16px', md: '20px' }} fontWeight={600}>
            Historial de cambios
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Paper variant="outlined">
            <TableDefault
              count={total}
              items={users}
              columns={COLUMNS}
              page={pagination.page + 1}
              pageSize={pagination.pageSize}
              loading={loading}
              messageLoading={'Cargando usuarios...'}
              showPagination
              handleChangePage={(page) => {
                setPagination({
                  ...pagination,
                  page: page,
                });
              }}
            />
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};
